import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { CmsPhase } from '../../integrations/contentful/types';
import { baseXInPixels, color, spacing } from '../../styles/theme';
import IconText from '../common/IconText';
import EllipsisOverflow from '../common/EllipsisOverflow';
import { determineIconForMemoryPhase } from '../../utils/memories';
import H from '../elements/H';
import Spacing from '../common/Spacing';
import { t } from '../../utils/i18n';
import ButtonText from '../elements/ButtonText';
import { DEFAULT_NAVBAR_ANCHOR_OFFSET_IN_PIXELS } from '../navigation/DefaultNavbar';
import HyperLink from '../elements/HyperLink';

interface MemoryToCProps {
  phases: readonly CmsPhase[];
  shipTrip: boolean;
}

const ICON_SIZE = 3;
const MemoryToC: React.FunctionComponent<MemoryToCProps> = ({
  phases,
  shipTrip
}) => {
  return (
    <div>
      <Spacing bottom={2}>
        <H styling="h5" color="gray">
          {t('Kokemukset')}
        </H>
      </Spacing>
      {phases.map((phase, index) => (
        <div className="phase-container" key={phase.sys.id}>
          <ScrollLink
            className="phase"
            to={phase.sys.id}
            offset={DEFAULT_NAVBAR_ANCHOR_OFFSET_IN_PIXELS}
            smooth
          >
            <HyperLink tag="div">
              <IconText
                key={phase.sys.id}
                icon={determineIconForMemoryPhase(phase, index === 0, shipTrip)}
                iconSize={ICON_SIZE}
                iconColor="purple-light"
              >
                <ButtonText variant="primary">
                  <EllipsisOverflow>{phase.fields.label}</EllipsisOverflow>
                </ButtonText>
              </IconText>
            </HyperLink>
          </ScrollLink>
          {index < phases.length - 1 && <div className="dashed-line" />}
        </div>
      ))}
      {/*language=CSS*/}
      <style jsx>{`
        .phase {
          display: flex;
          width: 100%;
        }
        .phase-container {
          cursor: pointer;
        }
        .dashed-line {
          border-left: dashed 2px ${color.light};
          margin-left: ${baseXInPixels(ICON_SIZE / 2) - 1}px;
          height: ${spacing.two};
        }
      `}</style>
    </div>
  );
};

export default MemoryToC;
